import { Box, Button, Card, CardContent } from '@mui/material'
import { styled } from '@mui/material/styles'
import { clientThemeV5 as mainTheme } from './ClientTheme'

export const EmbedContainer = styled('div')({
  overflow: 'hidden'
})

export const ResourceCard = styled(Card)(({ theme }) => ({
  borderRadius: 8,
  border: 'none',
  cursor: 'pointer',
  [theme.breakpoints.up('md')]: {
    boxShadow: '0px 0px 6px 1px rgb(0 0 0 / 8%) !important'
  }
}))

export const CatalogCard = styled(Card)(({ theme }) => ({
  borderRadius: 8,
  border: 'none',
  cursor: 'pointer',
  boxShadow: '6px 6px 20px rgb(0 0 0 / 10%)',
  [theme.breakpoints.down('sm')]: {
    padding: 0
  }
}))

export const DetailTitle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem !important',
    lineHeight: '1.235'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '16px'
  }
}))

export const MediaContainer = styled(Box)({
  background: mainTheme.palette.grey[50],
  borderRadius: '8px 8px 8px 0px',
  backgroundSize: 'cover !important',
  backgroundPosition: 'center !important',
  backgroundColor: mainTheme.palette.grey[100],
  position: 'relative',
  width: '100%',
  '& svg': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    color: mainTheme.palette.grey[400],
    fontSize: '65px'
  },
  [`@media (min-width: 900px)`]: {
    minHeight: '240px'
  },
  [`@media (max-width: 899px)`]: {
    minHeight: '158px'
  }
})

export const ContentButton = styled(Button)(({ theme }) => ({
  borderRadius: '8px 0px 0px 8px',
  backgroundColor: theme.palette.grey[700],
  opacity: '0.4',
  '&:hover': {
    backgroundColor: theme.palette.grey[800],
    opacity: '1'
  }
}))

export const OptionsMobile = styled('div')({
  // padding: '0px 10px'
})

export const TooltipContainer = styled('div')({
  maxWidth: 'fit-content'
})

export const Content = styled('div')({
  padding: '10px 0px'
})

export const Title = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'column'
  },
  [theme.breakpoints.down('sm')]: {
    gap: 4
  }
}))

export const ResourceText = styled(CardContent)(({ theme }) => ({
  padding: 12,
  paddingBottom: 0,
  [theme.breakpoints.up('sm')]: {
    minHeight: 74
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: 0,
    padding: 8
  }
}))

export const DateText = styled('div')({
  fontSize: '12px'
})

export const DownloadButton = styled(Button)(({ theme }) => ({
  maxWidth: 168,
  backgroundColor: theme.palette.error.light,
  color: theme.palette.primary.dark,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: 24,
    width: '100%',
    maxWidth: '100%'
  }
}))

export const ResourceImage = styled('img')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    borderRadius: 8,
    maxWidth: '80%',
    display: 'block',
    margin: '0 auto'
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    borderRadius: 8
  }
}))

export const MediaBox = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[50],
  borderRadius: '8px 8px 8px 0px',
  backgroundSize: 'cover !important',
  backgroundPosition: 'center !important',
  backgroundColor: theme.palette.grey[100],
  position: 'relative',
  width: '100%',
  '& svg': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    color: theme.palette.grey[400],
    fontSize: '65px'
  },
  [theme.breakpoints.up('md')]: {
    minHeight: '240px'
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '158px'
  }
}))

export const MediaLabel = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: '0',
  top: 8,
  width: 64,
  borderRadius: '4px 0px 0px 4px',
  padding: '0px 4px',
  background: 'linear-gradient(81.59deg, #A6813C -6.65%, #F2E3B3 50.89%, #BFA75E 110.5%)',
  '& h6': {
    fontWeight: 500
  },
  [theme.breakpoints.down('sm')]: {
    top: 0,
    padding: 0,
    '& p': {
      fontWeight: 500
    }
  }
}))

export const VipBlock = styled(Box)(({ theme }) => ({
  position: 'absolute',
  backgroundColor: 'rgba(250, 250, 250, 0.32)',
  backdropFilter: 'blur(6px)',
  display: 'grid',
  width: '100%',
  borderRadius: '0px 0px 16px 16px',
  '& h6, h5': {
    backgroundImage: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)',
    fill: '#B49568',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 500
  },
  [theme.breakpoints.up('md')]: {
    top: '166px',
    height: '46%'
  },
  [theme.breakpoints.down('sm')]: {
    top: '132px',
    height: '41%'
  }
}))
